// extracted by mini-css-extract-plugin
export default {"thinScroll":"style_thinScroll__BUeiR","ant-modal-body":"style_ant-modal-body__pombu","tagBtn":"style_tagBtn__vswgj","disabledRow":"style_disabledRow__im7+1"};